import LivePrices from "../../../pages/shared/live-prices/live-prices.component";

const LivePricesRoute = () => {
  return (
    <LivePrices/>
  )
}

export default LivePricesRoute